export const company = {
  name: "Goafreet",
  positioning: "Digital Marketing, Ecommerce, Technology & Brand Growth Partner",
  description: "Helping ambitious businesses build stronger brands, improve digital performance, manage ecommerce operations and create scalable digital products.",
  email: "info@goafreet.com",
  whatsapp: "919106981512",
  phone: "+91 9106981512",
  social: [
    ["LinkedIn", "https://www.linkedin.com/company/go-afreet"],
    ["Instagram", "https://www.instagram.com/go_afreet/"],
    ["Facebook", "https://www.facebook.com/goafreet-102140594767868/"],
    ["YouTube", "https://www.youtube.com/channel/UCVkmUg-aVFwSmFkJcsQUsIw/videos"],
  ],
};
